/**
 * Generates CSS styles for Froala content rendering.
 * Fixes font and spacing issues with character-based emoticons.
 * Uses theme values for consistency.
 */
export const getFroalaContentStyles = (): string => {
  return `
    /* Fix font and spacing issues with character-based emoticons in rendered content */
    .fr-view span:not(.fr-emoticon-img),
    .fr-view span:not(.fr-emoticon-img) *,
    .fr-element span:not(.fr-emoticon-img),
    .fr-element span:not(.fr-emoticon-img) * {
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      vertical-align: baseline !important;
    }

    /* Character-based emoticons: keep inline so they flow with text */
    .fr-view span.fr-emoticon:not(.fr-emoticon-img),
    .fr-element span.fr-emoticon:not(.fr-emoticon-img) {
      display: inline !important;
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      vertical-align: baseline !important;
    }

    /* Image-based emoticons: need inline-block for width/height to take effect */
    .fr-view span.fr-emoticon.fr-emoticon-img,
    .fr-element span.fr-emoticon.fr-emoticon-img {
      display: inline-block !important;
      min-width: 20px !important;
      min-height: 20px !important;
      width: 1em !important;
      height: 1em !important;
      background-size: contain !important;
      background-repeat: no-repeat !important;
      vertical-align: middle !important;
      line-height: 1 !important;
    }

    /* Ensure paragraphs and divs maintain consistent styling */
    .fr-view p,
    .fr-view div,
    .fr-element p,
    .fr-element div {
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
    }

    /* Ensure consistent font rendering */
    .fr-view,
    .fr-element {
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      color: inherit !important;
    }
  `
}

/**
 * Injects Froala content rendering styles globally.
 * Call this once in your app to ensure styles are available everywhere.
 */
export const injectFroalaContentStyles = () => {
  if (typeof window === 'undefined') return

  const styleId = 'froala-content-rendering-styles'
  let styleElement = document.getElementById(styleId) as HTMLStyleElement | null

  if (!styleElement) {
    styleElement = document.createElement('style')
    styleElement.id = styleId
    styleElement.textContent = getFroalaContentStyles()
    document.head.appendChild(styleElement)
  }
}
